import { infiniteQueryOptions } from '@tanstack/react-query';

import { apiAdminViewsFetch, apiIntroducerDashboardsFetch } from '..';
import { INTRODUCER_DASHBOARD_QUERY_KEYS } from './queries';
import {
  AdminFundsResponse,
  AdminIntroducersResponse,
  GetAdminFundsParams,
  GetAdminIntroducersParams,
  GetFundsParams,
  GetInvestorsParams,
  IntroducerDashboardFund,
  IntroducerDashboardInvestor,
  PaginatedResponse,
} from './types';

export const _getIntroducerInvestorsInfinite = (
  introducerId?: string,
  params?: Omit<GetInvestorsParams, 'page' | 'limit'>,
) =>
  infiniteQueryOptions({
    enabled: !!introducerId,
    queryKey: [INTRODUCER_DASHBOARD_QUERY_KEYS.investors, introducerId, 'infinite', params],
    queryFn: ({ pageParam = 1 }) =>
      apiIntroducerDashboardsFetch<PaginatedResponse<IntroducerDashboardInvestor>>(
        `/${introducerId}/investors`,
        { params: { ...params, page: pageParam, limit: 20 } },
      ),
    initialPageParam: 1,
    getNextPageParam: (lastPage) =>
      lastPage.pagination.page < lastPage.pagination.totalPages
        ? lastPage.pagination.page + 1
        : undefined,
    refetchOnMount: true,
    retry: 1,
  });

export const _getIntroducerFundsInfinite = (
  introducerId?: string,
  params?: Omit<GetFundsParams, 'page' | 'limit'>,
) =>
  infiniteQueryOptions({
    enabled: !!introducerId,
    queryKey: [INTRODUCER_DASHBOARD_QUERY_KEYS.funds, introducerId, 'infinite', params],
    queryFn: ({ pageParam = 1 }) =>
      apiIntroducerDashboardsFetch<PaginatedResponse<IntroducerDashboardFund>>(
        `/${introducerId}/funds`,
        { params: { ...params, page: pageParam, limit: 20 } },
      ),
    initialPageParam: 1,
    getNextPageParam: (lastPage) =>
      lastPage.pagination.page < lastPage.pagination.totalPages
        ? lastPage.pagination.page + 1
        : undefined,
    refetchOnMount: true,
    retry: 1,
  });

export const _getAdminIntroducerFundsInfinite = (
  params?: Omit<GetAdminFundsParams, 'page' | 'limit'>,
) =>
  infiniteQueryOptions({
    queryKey: [INTRODUCER_DASHBOARD_QUERY_KEYS.adminFunds, 'infinite', params],
    queryFn: ({ pageParam = 1 }) =>
      apiAdminViewsFetch<AdminFundsResponse>('/introducer/funds', {
        params: { ...params, page: pageParam, limit: 20 },
      }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) =>
      lastPage.pagination.page < lastPage.pagination.totalPages
        ? lastPage.pagination.page + 1
        : undefined,
    refetchOnMount: true,
    retry: 1,
  });

export const _getAdminIntroducersInfinite = (
  params?: Omit<GetAdminIntroducersParams, 'page' | 'limit'>,
) =>
  infiniteQueryOptions({
    queryKey: [INTRODUCER_DASHBOARD_QUERY_KEYS.adminIntroducers, 'infinite', params],
    queryFn: ({ pageParam = 1 }) =>
      apiAdminViewsFetch<AdminIntroducersResponse>('/introducer/introducers', {
        params: { ...params, page: pageParam, limit: 20 },
      }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) =>
      lastPage.pagination.page < lastPage.pagination.totalPages
        ? lastPage.pagination.page + 1
        : undefined,
    refetchOnMount: true,
    retry: 1,
  });
